(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-costing"] && !Shopify.designMode) return;
  try {
    
    (function() {
      var root = document.querySelector('[data-fabx-costing-calculator]');
      if (!root) return;

      var costListEl = root.querySelector('[data-cost-list]');
      var costRows = [];
      var rowCounter = 0;

      var EXAMPLE_ROWS = [
        {
                "classification": "necessary",
                "category": "Sample",
                "description": "Physical scarf sample",
                "batch": "Sample",
                "supplier": "Shrelo",
                "qty": 1,
                "costType": "total",
                "amount": 30.0,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "yes",
                "notes": ""
        },
        {
                "classification": "internal_mistake",
                "category": "Internal Courier",
                "description": "Supplier to FABX - Sample Shipment",
                "batch": "Sample",
                "supplier": "DHL",
                "qty": 1,
                "costType": "total",
                "amount": 44.59,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "yes",
                "notes": ""
        },
        {
                "classification": "necessary",
                "category": "Courier",
                "description": "Lalamove delivery to client — Sample",
                "batch": "Sample",
                "supplier": "Lalamove",
                "qty": 1,
                "costType": "total",
                "amount": 15.7,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "yes",
                "notes": ""
        },
        {
                "classification": "necessary",
                "category": "Product",
                "description": "Scarf 45 Satin Hermes + test print photo — Batch 1",
                "batch": "Batch 1",
                "supplier": "Shrelo",
                "qty": 102,
                "costType": "total",
                "amount": 228.87,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "yes",
                "notes": ""
        },
        {
                "classification": "necessary",
                "category": "Product",
                "description": "Scarf 45 Satin Hermes — Batch 2",
                "batch": "Batch 2",
                "supplier": "Shrelo",
                "qty": 198,
                "costType": "total",
                "amount": 451.87,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "yes",
                "notes": ""
        },
        {
                "classification": "necessary",
                "category": "Supplies",
                "description": "OPP + carton supplies sent to supplier",
                "batch": "Production Prep",
                "supplier": "Shopee ID",
                "qty": 1,
                "costType": "total",
                "amount": 28.16,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "yes",
                "notes": ""
        },
        {
                "classification": "development",
                "category": "Collateral",
                "description": "Insert care card — standby",
                "batch": "Premium Presentation",
                "supplier": "Gogoprint",
                "qty": 500,
                "costType": "total",
                "amount": 56.03,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "no",
                "notes": "On standby in case SIngaPrinting is late"
        },
        {
                "classification": "necessary",
                "category": "Collateral",
                "description": "Insert care card — final",
                "batch": "Premium Presentation",
                "supplier": "SingaPrinting",
                "qty": 400,
                "costType": "total",
                "amount": 100.0,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "yes",
                "notes": ""
        },
        {
                "classification": "development",
                "category": "Packaging",
                "description": "Rectangle Sticker - 9.5cm x 2.5cm — wrong material",
                "batch": "Premium Presentation",
                "supplier": "Gogoprint",
                "qty": 400,
                "costType": "total",
                "amount": 99.9,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "no",
                "notes": "On standby incase DTF doesn't work — wrong material test"
        },
        {
                "classification": "necessary",
                "category": "Packaging",
                "description": "Rectangle Sticker - 9.5cm x 2.5cm",
                "batch": "Premium Presentation",
                "supplier": "Gogoprint",
                "qty": 400,
                "costType": "total",
                "amount": 92.08,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "no",
                "notes": "On standby incase DTF doesn't work"
        },
        {
                "classification": "development",
                "category": "Packaging",
                "description": "UV DTF Sticker — A2 sheets — wrong material",
                "batch": "Premium Presentation",
                "supplier": "AE Stamp",
                "qty": 5,
                "costType": "total",
                "amount": 136.25,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "no",
                "notes": ""
        },
        {
                "classification": "necessary",
                "category": "Packaging",
                "description": "UV DTF Sticker — 336pcs",
                "batch": "Premium Presentation",
                "supplier": "Expressprint",
                "qty": 7,
                "costType": "total",
                "amount": 226.73,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "yes",
                "notes": ""
        },
        {
                "classification": "necessary",
                "category": "Packaging",
                "description": "Premium envelope / box / stocked packaging allocation — Scarf 45",
                "batch": "Premium Presentation",
                "supplier": "Sinicline",
                "qty": 230,
                "costType": "unit",
                "amount": 1.15,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "yes",
                "notes": ""
        },
        {
                "classification": "necessary",
                "category": "Packaging",
                "description": "Premium envelope / box / stocked packaging allocation — Scarf 50",
                "batch": "Premium Presentation",
                "supplier": "Sinicline",
                "qty": 70,
                "costType": "unit",
                "amount": 1.31,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "yes",
                "notes": ""
        },
        {
                "classification": "necessary",
                "category": "Supplies",
                "description": "OPP + carton box for delivery to client",
                "batch": "Packing",
                "supplier": "Shopee",
                "qty": 1,
                "costType": "total",
                "amount": 36.12,
                "currency": "SGD",
                "fx": 1,
                "status": "actual",
                "repeat": "yes",
                "notes": ""
        },
        {
                "classification": "necessary",
                "category": "Internal Courier",
                "description": "Supplier to FABX — Batch 2 DHL Shipment",
                "batch": "Batch 2",
                "supplier": "DHL",
                "qty": 1,
                "costType": "total",
                "amount": 200.0,
                "currency": "SGD",
                "fx": 1,
                "status": "estimated",
                "repeat": "yes",
                "notes": ""
        },
        {
                "classification": "necessary",
                "category": "Courier",
                "description": "Lalamove delivery to client — 300pcs",
                "batch": "Courier",
                "supplier": "Lalamove",
                "qty": 1,
                "costType": "total",
                "amount": 30.0,
                "currency": "SGD",
                "fx": 1,
                "status": "estimated",
                "repeat": "yes",
                "notes": ""
        }
];

      function clone(obj) {
        return JSON.parse(JSON.stringify(obj));
      }

      function money(n) {
        n = Number(n || 0);
        return 'SGD ' + n.toLocaleString('en-SG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }

      function percent(n) {
        if (!isFinite(n)) return '0.0%';
        return (n * 100).toFixed(1) + '%';
      }

      function numberValue(value) {
        var n = parseFloat(value);
        return isFinite(n) ? n : 0;
      }

      function csvEscape(value) {
        var str = String(value == null ? '' : value);
        if (/[",\n\r]/.test(str)) return '"' + str.replace(/"/g, '""') + '"';
        return str;
      }

      function htmlEscape(value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function slug(value) {
        return String(value || 'fabx-project-costing')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '') || 'fabx-project-costing';
      }

      function getProject() {
        var data = {};
        root.querySelectorAll('[data-project]').forEach(function(el) {
          data[el.getAttribute('data-project')] = el.value;
        });
        data.revenueSgd = numberValue(data.revenueSgd);
        data.totalQty = numberValue(data.totalQty);
        return data;
      }

      function setProject(data) {
        Object.keys(data).forEach(function(key) {
          var el = root.querySelector('[data-project="' + key + '"]');
          if (el) el.value = data[key];
        });
      }

      function getRowAmount(row) {
        var qty = numberValue(row.qty);
        var amount = numberValue(row.amount);
        var base = row.costType === 'unit' ? qty * amount : amount;
        var defaultFx = { SGD: 1, USD: 1.35, IDR: 0.000075 };
        var fx = defaultFx[row.currency] || 1;
        var sgd = base * fx;
        var counts = row.status === 'actual' || row.status === 'estimated';
        return {
          original: base,
          sgd: counts ? sgd : 0,
          rawSgd: sgd,
          repeatSgd: counts && row.repeat === 'yes' ? sgd : 0,
          counts: counts
        };
      }

      function totals() {
        var project = getProject();
        var actualCost = 0;
        var repeatCost = 0;
        var estimatedCost = 0;
        var oneOffCost = 0;
        var excludedRaw = 0;
        var categoryTotals = {};
        var classificationTotals = { necessary: 0, development: 0, internal_mistake: 0, supplier_mistake: 0, client_change: 0, other: 0 };

        costRows.forEach(function(row) {
          var amt = getRowAmount(row);
          actualCost += amt.sgd;
          repeatCost += amt.repeatSgd;
          if (row.status === 'estimated') estimatedCost += amt.sgd;
          if (amt.counts && row.repeat !== 'yes') oneOffCost += amt.sgd;
          if (!amt.counts) excludedRaw += amt.rawSgd;
          if (!categoryTotals[row.category]) categoryTotals[row.category] = 0;
          categoryTotals[row.category] += amt.sgd;
          var classification = row.classification || 'necessary';
          if (!classificationTotals[classification]) classificationTotals[classification] = 0;
          classificationTotals[classification] += amt.sgd;
        });

        var revenue = project.revenueSgd;
        var qty = project.totalQty || 0;
        var actualProfit = revenue - actualCost;
        var repeatProfit = revenue - repeatCost;

        return {
          project: project,
          revenue: revenue,
          qty: qty,
          actualCost: actualCost,
          repeatCost: repeatCost,
          actualProfit: actualProfit,
          repeatProfit: repeatProfit,
          actualMargin: revenue > 0 ? actualProfit / revenue : 0,
          repeatMargin: revenue > 0 ? repeatProfit / revenue : 0,
          actualCostPc: qty > 0 ? actualCost / qty : 0,
          repeatCostPc: qty > 0 ? repeatCost / qty : 0,
          revenuePc: qty > 0 ? revenue / qty : 0,
          estimatedCost: estimatedCost,
          oneOffCost: oneOffCost,
          excludedRaw: excludedRaw,
          categoryTotals: categoryTotals,
          classificationTotals: classificationTotals,
          avoidableCost: (classificationTotals.internal_mistake || 0) + (classificationTotals.supplier_mistake || 0)
        };
      }

      function marginClass(margin) {
        if (margin >= 0.55) return 'fcc-status-good';
        if (margin >= 0.4) return 'fcc-status-watch';
        return 'fcc-status-risk';
      }

      function updateSummary() {
        var t = totals();
        root.querySelector('[data-summary="revenue"]').textContent = money(t.revenue);
        root.querySelector('[data-summary="quantity"]').textContent = Math.round(t.qty || 0).toLocaleString('en-SG') + ' pcs';
        root.querySelector('[data-summary="actualCost"]').textContent = money(t.actualCost);
        root.querySelector('[data-summary="actualProfit"]').textContent = money(t.actualProfit);
        root.querySelector('[data-summary="actualMargin"]').textContent = percent(t.actualMargin);
        root.querySelector('[data-summary="actualCostPc"]').textContent = money(t.actualCostPc);
        root.querySelector('[data-summary="repeatCost"]').textContent = money(t.repeatCost);
        root.querySelector('[data-summary="repeatMargin"]').textContent = percent(t.repeatMargin);
        root.querySelector('[data-summary="revenuePc"]').textContent = money(t.revenuePc);
        root.querySelector('[data-summary="repeatCostPc"]').textContent = money(t.repeatCostPc);
        root.querySelector('[data-summary="necessaryCost"]').textContent = money(t.classificationTotals.necessary || 0);
        root.querySelector('[data-summary="developmentCost"]').textContent = money(t.classificationTotals.development || 0);
        root.querySelector('[data-summary="internalMistakeCost"]').textContent = money(t.classificationTotals.internal_mistake || 0);
        root.querySelector('[data-summary="supplierMistakeCost"]').textContent = money(t.classificationTotals.supplier_mistake || 0);
        root.querySelector('[data-summary="clientChangeCost"]').textContent = money(t.classificationTotals.client_change || 0);
        root.querySelector('[data-summary="avoidableCost"]').textContent = money(t.avoidableCost || 0);

        var badge = root.querySelector('[data-margin-badge]');
        badge.textContent = 'GM ' + percent(t.actualMargin);
        badge.className = 'fcc-badge ' + marginClass(t.actualMargin);

        root.querySelector('[data-summary-note]').textContent =
          'Estimated cost included in actual: ' + money(t.estimatedCost) + '. Non-repeat cost: ' + money(t.oneOffCost) + '. Avoidable mistake cost: ' + money(t.avoidableCost) + '. Excluded/included-elsewhere raw value: ' + money(t.excludedRaw) + '. Unit cost uses ' + (t.qty || 0) + ' pcs.';
      }

      function updateRowFromCard(card) {
        var id = card.getAttribute('data-row-id');
        var row = costRows.find(function(item) { return String(item.id) === String(id); });
        if (!row) return;
        card.querySelectorAll('[data-field]').forEach(function(el) {
          row[el.getAttribute('data-field')] = el.value;
        });
        updateSummary();
      }

      function option(value, label, selected) {
        return '<option value="' + htmlEscape(value) + '"' + (value === selected ? ' selected' : '') + '>' + htmlEscape(label) + '</option>';
      }

      function rowTemplate(row, index) {
        return '<div class="fcc-cost-card" data-row-id="' + row.id + '">' +
          '<div class="fcc-cost-top">' +
            '<div class="fcc-cost-label">Cost Line ' + (index + 1) + '</div>' +
            '<button type="button" class="fcc-remove" data-remove-row aria-label="Remove cost line">×</button>' +
          '</div>' +

          '<div class="fcc-cost-grid">' +
            '<div class="fcc-field"><label>Batch / Stage</label><input type="text" data-field="batch" value="' + htmlEscape(row.batch) + '" placeholder="e.g. Batch 1, Packaging Final"></div>' +
            '<div class="fcc-field"><label>Cost Category</label><select data-field="category">' +
              option('Sample', 'Sample', row.category) +
              option('Product', 'Product', row.category) +
              option('Internal Courier', 'Internal Courier', row.category) +
              option('Packaging', 'Packaging', row.category) +
              option('Supplies', 'Supplies', row.category) +
              option('Collateral', 'Collateral', row.category) +
              option('Packing', 'Packing', row.category) +
              option('Courier', 'Courier', row.category) +
            '</select></div>' +
          '</div>' +

          '<div class="fcc-cost-grid-full">' +
            '<div class="fcc-field"><label>Cost Classification</label><select data-field="classification">' +
              option('necessary', 'Necessary project cost', row.classification) +
              option('development', 'Development / supplier testing', row.classification) +
              option('internal_mistake', 'Internal mistake / wrong choice', row.classification) +
              option('supplier_mistake', 'Supplier mistake / unusable output', row.classification) +
              option('client_change', 'Client change / extra request', row.classification) +
              option('other', 'Other / review manually', row.classification) +
            '</select></div>' +
          '</div>' +

          '<div class="fcc-cost-grid">' +
            '<div class="fcc-field"><label>Supplier / Vendor</label><input type="text" data-field="supplier" value="' + htmlEscape(row.supplier) + '" placeholder="Supplier or vendor name"></div>' +
            '<div class="fcc-field"><label>Description / Cost Item</label><input type="text" data-field="description" value="' + htmlEscape(row.description) + '" placeholder="Describe the cost item"></div>' +
          '</div>' +

          '<div class="fcc-cost-grid-4">' +
            '<div class="fcc-field"><label>Cost Type</label><select data-field="costType">' +
              option('total', 'Total amount', row.costType) +
              option('unit', 'Cost per pc', row.costType) +
            '</select></div>' +
            '<div class="fcc-field"><label>Amount</label><input type="number" min="0" step="0.01" data-field="amount" value="' + htmlEscape(row.amount) + '" placeholder="0.00"></div>' +
            '<div class="fcc-field"><label>Currency</label><select data-field="currency">' +
              option('SGD', 'SGD', row.currency) +
              option('USD', 'USD', row.currency) +
              option('IDR', 'IDR', row.currency) +
            '</select></div>' +
            '<div class="fcc-field"><label>Qty</label><input type="number" min="0" step="0.01" data-field="qty" value="' + htmlEscape(row.qty) + '" placeholder="1"></div>' +
          '</div>' +

          '<div class="fcc-cost-grid-wide">' +
            '<div class="fcc-field"><label>Notes</label><input type="text" data-field="notes" value="' + htmlEscape(row.notes) + '" placeholder="Optional note"></div>' +
            '<div class="fcc-field"><label>Counted SGD</label><input type="text" readonly data-row-total value="' + money(getRowAmount(row).sgd) + '"></div>' +
          '</div>' +

          '<div class="fcc-cost-grid-2">' +
            '<div class="fcc-field"><label>Repeat Costing?</label><select data-field="repeat">' +
              option('yes', 'Yes — include in repeat costing', row.repeat) +
              option('no', 'No — one-off test / reprint / mistake', row.repeat) +
            '</select></div>' +
            '<div class="fcc-field"><label>Status</label><select data-field="status">' +
              option('actual', 'Actual / Count', row.status) +
              option('estimated', 'Estimated / Count', row.status) +
              option('included', 'Included elsewhere', row.status) +
              option('exclude', 'Exclude / Not used', row.status) +
            '</select></div>' +
          '</div>' +
        '</div>';
      }

      function renderRows() {
        costListEl.innerHTML = costRows.map(rowTemplate).join('');
        costListEl.querySelectorAll('.fcc-cost-card').forEach(function(card) {
          card.addEventListener('input', function() {
            updateRowFromCard(card);
            var id = card.getAttribute('data-row-id');
            var row = costRows.find(function(item) { return String(item.id) === String(id); });
            var totalInput = card.querySelector('[data-row-total]');
            if (row && totalInput) totalInput.value = money(getRowAmount(row).sgd);
          });
          card.addEventListener('change', function() {
            updateRowFromCard(card);
            var id = card.getAttribute('data-row-id');
            var row = costRows.find(function(item) { return String(item.id) === String(id); });
            var totalInput = card.querySelector('[data-row-total]');
            if (row && totalInput) totalInput.value = money(getRowAmount(row).sgd);
          });
        });
        costListEl.querySelectorAll('[data-remove-row]').forEach(function(button) {
          button.addEventListener('click', function() {
            var card = button.closest('.fcc-cost-card');
            var id = card.getAttribute('data-row-id');
            costRows = costRows.filter(function(item) { return String(item.id) !== String(id); });
            renderRows();
            updateSummary();
          });
        });
        updateSummary();
      }

      function addCostRow(data) {
        var row = Object.assign({
          classification: 'necessary', category: 'Product', description: '', batch: 'General', supplier: '', qty: 1,
          costType: 'total', amount: 0, currency: 'SGD', fx: 1,
          status: 'actual', repeat: 'yes', notes: ''
        }, data || {});
        row.id = ++rowCounter;
        costRows.push(row);
        renderRows();
      }

      function loadExample() {
        var choice = root.querySelector('[data-example-choice]').value;
        costRows = [];
        rowCounter = 0;

        if (choice === 'us_embassy') {
          setProject({
            projectName: 'US Embassy',
            projectRef: 'QU-0006 / 19SN1026P0612',
            revenueSgd: 10865,
            totalQty: 500,
            item: 'Pocket Square 35',
            material: 'Satin Hermes',
            packaging: 'OPP + Custom Presentation Envelope',
            currencyNote: 'Use SGD after conversion for final costing',
            notes: 'Loaded from the completed US Embassy costing CSV. Review or replace values as needed.'
          });
          [
            {
                        "classification": "client_change",
                        "category": "Courier",
                        "description": "Delivery to client — FABX Samples",
                        "batch": "Sample",
                        "supplier": "Lalamove",
                        "qty": 1,
                        "costType": "total",
                        "amount": 18.0,
                        "currency": "SGD",
                        "fx": 1,
                        "status": "actual",
                        "repeat": "yes",
                        "notes": ""
            },
            {
                        "classification": "necessary",
                        "category": "Product",
                        "description": "Pocket Square Scarf 35 Satin Hermes + test print photo — Batch 1",
                        "batch": "Batch 1",
                        "supplier": "Shrelo",
                        "qty": 102,
                        "costType": "total",
                        "amount": 186.44,
                        "currency": "SGD",
                        "fx": 1,
                        "status": "actual",
                        "repeat": "yes",
                        "notes": ""
            },
            {
                        "classification": "necessary",
                        "category": "Product",
                        "description": "Pocket Square Scarf 35 Satin Hermes — Batch 2",
                        "batch": "Batch 2",
                        "supplier": "Shrelo",
                        "qty": 399,
                        "costType": "total",
                        "amount": 725.67,
                        "currency": "SGD",
                        "fx": 1,
                        "status": "actual",
                        "repeat": "yes",
                        "notes": ""
            },
            {
                        "classification": "necessary",
                        "category": "Supplies",
                        "description": "Sent to supplier — OPP + carton supplier",
                        "batch": "Production Prep",
                        "supplier": "Shopee ID",
                        "qty": 1,
                        "costType": "total",
                        "amount": 28.16,
                        "currency": "SGD",
                        "fx": 1,
                        "status": "actual",
                        "repeat": "yes",
                        "notes": ""
            },
            {
                        "classification": "necessary",
                        "category": "Internal Courier",
                        "description": "Supplier to FABX - Batch 1 Shipment",
                        "batch": "Batch 1",
                        "supplier": "DHL",
                        "qty": 1,
                        "costType": "total",
                        "amount": 92.95,
                        "currency": "SGD",
                        "fx": 1,
                        "status": "actual",
                        "repeat": "yes",
                        "notes": ""
            },
            {
                        "classification": "necessary",
                        "category": "Packaging",
                        "description": "Custom scarf envelope — coloplan + gold foil stamp",
                        "batch": "Premium Presentation",
                        "supplier": "Sinicline",
                        "qty": 610,
                        "costType": "total",
                        "amount": 912.22,
                        "currency": "SGD",
                        "fx": 1,
                        "status": "actual",
                        "repeat": "yes",
                        "notes": ""
            },
            {
                        "classification": "necessary",
                        "category": "Collateral",
                        "description": "SingaPrinting care card final",
                        "batch": "Premium Presentation",
                        "supplier": "SingaPrinting",
                        "qty": 500,
                        "costType": "total",
                        "amount": 123.0,
                        "currency": "SGD",
                        "fx": 1,
                        "status": "actual",
                        "repeat": "yes",
                        "notes": ""
            },
            {
                        "classification": "necessary",
                        "category": "Courier",
                        "description": "Delivery to client — Batch 1",
                        "batch": "Batch 1",
                        "supplier": "Lalamove",
                        "qty": 5,
                        "costType": "total",
                        "amount": 22.1,
                        "currency": "SGD",
                        "fx": 1,
                        "status": "actual",
                        "repeat": "yes",
                        "notes": ""
            },
            {
                        "classification": "necessary",
                        "category": "Courier",
                        "description": "Supplier to FABX — Batch 2 Shipment",
                        "batch": "Batch 2",
                        "supplier": "TIM Express",
                        "qty": 400,
                        "costType": "total",
                        "amount": 39.22,
                        "currency": "SGD",
                        "fx": 1,
                        "status": "actual",
                        "repeat": "yes",
                        "notes": ""
            },
            {
                        "classification": "necessary",
                        "category": "Supplies",
                        "description": "OPP + carton box for delivery to client",
                        "batch": "Packing",
                        "supplier": "Shopee",
                        "qty": 1,
                        "costType": "total",
                        "amount": 36.12,
                        "currency": "SGD",
                        "fx": 1,
                        "status": "actual",
                        "repeat": "yes",
                        "notes": ""
            },
            {
                        "classification": "necessary",
                        "category": "Courier",
                        "description": "Delivery to client — Batch 2",
                        "batch": "Batch 2",
                        "supplier": "Lalamove",
                        "qty": 1,
                        "costType": "total",
                        "amount": 30.0,
                        "currency": "SGD",
                        "fx": 1,
                        "status": "estimated",
                        "repeat": "yes",
                        "notes": ""
            }
].forEach(function(row) { addCostRow(clone(row)); });
        } else {
          setProject({
            projectName: 'IHRP',
            projectRef: 'QU-0005',
            revenueSgd: 5985,
            totalQty: 300,
            item: 'Scarf 45',
            material: 'Satin Hermes',
            packaging: 'Premium Packaging',
            currencyNote: 'Use SGD after conversion for final costing',
            notes: 'Loaded from the completed IHRP costing CSV. Batch 1: 102 pcs. Batch 2: 198 pcs. Review or replace values as needed.'
          });
          EXAMPLE_ROWS.forEach(function(row) { addCostRow(clone(row)); });
        }
        renderRows();
      }

      function initialiseBlank() {
        setProject({
          projectName: '', projectRef: '', revenueSgd: '', totalQty: '', item: '',
          material: '', packaging: '', currencyNote: '', notes: ''
        });
        costRows = [];
        rowCounter = 0;
        addCostRow({
          classification: 'necessary', category: 'Product', description: '', batch: '', supplier: '', qty: 1,
          costType: 'total', amount: '', currency: 'SGD', status: 'actual', repeat: 'yes', notes: ''
        });
        renderRows();
      }

      function buildExportRows() {
        return costRows.map(function(row, index) {
          var amt = getRowAmount(row);
          return {
            No: index + 1,
            Classification: row.classification,
            Category: row.category,
            Description: row.description,
            Batch: row.batch,
            Supplier: row.supplier,
            Qty: numberValue(row.qty),
            'Cost Type': row.costType === 'unit' ? 'Cost per pc' : 'Total amount',
            Amount: numberValue(row.amount),
            Currency: row.currency,
            Status: row.status,
            'Repeat Costing': row.repeat === 'yes' ? 'Yes' : 'No',
            'Original Total': amt.original,
            'Raw SGD': amt.rawSgd,
            'Actual Counted SGD': amt.sgd,
            'Repeat Counted SGD': amt.repeatSgd,
            Notes: row.notes
          };
        });
      }

      function downloadCsvFile(content, filename) {
        var csvContent = '\uFEFF' + content;
        var anchor = document.createElement('a');
        anchor.style.display = 'none';
        anchor.setAttribute('download', filename);

        try {
          var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          var url = (window.URL || window.webkitURL).createObjectURL(blob);
          anchor.href = url;
          document.body.appendChild(anchor);
          anchor.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          document.body.removeChild(anchor);
          setTimeout(function() {
            (window.URL || window.webkitURL).revokeObjectURL(url);
          }, 1500);
        } catch (error) {
          var dataUri = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(content);
          anchor.href = dataUri;
          document.body.appendChild(anchor);
          anchor.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          document.body.removeChild(anchor);
        }
      }

      function downloadCsv() {
        var p = getProject();
        var t = totals();
        var rows = buildExportRows();
        var headers = Object.keys(rows[0] || { No: '', Category: '', Description: '' });
        var output = [];
        output.push(['FABX Project Costing Export'].map(csvEscape).join(','));
        output.push(['Project / Client', p.projectName].map(csvEscape).join(','));
        output.push(['Quote / PO / Invoice Ref', p.projectRef].map(csvEscape).join(','));
        output.push(['Revenue SGD', t.revenue].map(csvEscape).join(','));
        output.push(['Quantity / Pcs', t.qty].map(csvEscape).join(','));
        output.push(['Actual Project Cost SGD', t.actualCost].map(csvEscape).join(','));
        output.push(['Actual Gross Profit SGD', t.actualProfit].map(csvEscape).join(','));
        output.push(['Actual Gross Margin', percent(t.actualMargin)].map(csvEscape).join(','));
        output.push(['Actual Cost per Pc SGD', t.actualCostPc].map(csvEscape).join(','));
        output.push(['Repeat Project Cost SGD', t.repeatCost].map(csvEscape).join(','));
        output.push(['Repeat Gross Margin', percent(t.repeatMargin)].map(csvEscape).join(','));
        output.push(['Revenue per Pc SGD', t.revenuePc].map(csvEscape).join(','));
        output.push(['Repeat Cost per Pc SGD', t.repeatCostPc].map(csvEscape).join(','));
        output.push('');
        output.push(['Cost Classification Breakdown'].map(csvEscape).join(','));
        output.push(['Necessary Project Costs SGD', t.classificationTotals.necessary || 0].map(csvEscape).join(','));
        output.push(['Development / Supplier Testing SGD', t.classificationTotals.development || 0].map(csvEscape).join(','));
        output.push(['Internal Mistakes / Wrong Choice SGD', t.classificationTotals.internal_mistake || 0].map(csvEscape).join(','));
        output.push(['Supplier Mistake / Unusable Output SGD', t.classificationTotals.supplier_mistake || 0].map(csvEscape).join(','));
        output.push(['Client Change / Extra Request SGD', t.classificationTotals.client_change || 0].map(csvEscape).join(','));
        output.push(['Other / Review Manually SGD', t.classificationTotals.other || 0].map(csvEscape).join(','));
        output.push(['Total Avoidable / Mistake Cost SGD', t.avoidableCost || 0].map(csvEscape).join(','));
        output.push('');
        output.push(headers.map(csvEscape).join(','));
        rows.forEach(function(row) {
          output.push(headers.map(function(h) { return csvEscape(row[h]); }).join(','));
        });
        downloadCsvFile(output.join('\r\n'), slug(p.projectName + '-' + p.projectRef) + '-costing.csv');
      }

      root.querySelectorAll('[data-project]').forEach(function(el) {
        el.addEventListener('input', updateSummary);
        el.addEventListener('change', updateSummary);
      });

      root.querySelector('[data-add-cost]').addEventListener('click', function() { addCostRow(); });
      root.querySelector('[data-add-cost-bottom]').addEventListener('click', function() { addCostRow(); });
      root.querySelector('[data-load-example]').addEventListener('click', loadExample);
      root.querySelector('[data-download-csv]').addEventListener('click', downloadCsv);

      initialiseBlank();
    })();

  } catch(e) { console.error(e); }
})();
})();
